import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { curry, isNil, path } from 'ramda';

/**
 * Returns the namespace of an action.
 */
var getNamespaceByAction = function getNamespaceByAction(action) {
  var _action$meta;

  return action === null || action === void 0 ? void 0 : (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.namespace;
};

var mergeNamespace = curry(function (overwrite, namespace, action) {
  var _getNamespaceByAction;

  if (isNil(namespace)) {
    return action;
  }

  var nextNamespace = overwrite ? namespace : (_getNamespaceByAction = getNamespaceByAction(action)) !== null && _getNamespaceByAction !== void 0 ? _getNamespaceByAction : namespace;

  if (typeof action === 'function') {
    var nextAction = function nextAction() {
      return action.apply(void 0, arguments);
    };

    nextAction.meta = {
      namespace: nextNamespace
    };
    return nextAction;
  }

  return _objectSpread(_objectSpread({}, action), {}, {
    meta: _objectSpread(_objectSpread({}, action.meta), {}, {
      namespace: nextNamespace
    })
  });
});

/**
 * Associates an action with a namespace, overwriting any previous namespace.
 */
var attachNamespace = mergeNamespace(true);

/**
 * Associates an action with a namespace unless it is already associated with some namespace.
 */
var defaultNamespace = mergeNamespace(false);

var DEFAULT_FEATURE = 'namespaces';
var NAMESPACE_PREVENTED = 'NAMESPACE_PREVENTED';

/**
 * Checks whether an action is from a namespace.
 */
var isActionFromNamespace = curry(function (namespace, action) {
  var actionNamespace = getNamespaceByAction(action);

  if (!namespace || !actionNamespace || actionNamespace === NAMESPACE_PREVENTED) {
    return true;
  }

  return namespace === actionNamespace;
});

/**
 * Returns Redux state by feature and namespace.
 */
var getStateByFeatureAndNamespace = curry(function (feature, namespace, state) {
  return path([feature, namespace], state);
});

/**
 * Returns Redux state by feature and action namespace.
 */
var getStateByFeatureAndAction = curry(function (feature, action, state) {
  var namespace = getNamespaceByAction(action);

  if (typeof namespace === 'undefined') {
    return undefined;
  }

  return getStateByFeatureAndNamespace(feature, namespace, state);
});

/**
 * Returns Redux state by action namespace.
 */

var getStateByAction = getStateByFeatureAndAction(DEFAULT_FEATURE);

/**
 * Returns Redux state by namespace.
 */

var getStateByNamespace = getStateByFeatureAndNamespace(DEFAULT_FEATURE);

/**
 * Associates an action with a "global" namespace, overwriting any previous namespace.
 */
var preventNamespace = function preventNamespace(action) {
  return mergeNamespace(true, NAMESPACE_PREVENTED, action);
};

export { DEFAULT_FEATURE, NAMESPACE_PREVENTED, attachNamespace, defaultNamespace, getNamespaceByAction, getStateByAction, getStateByFeatureAndAction, getStateByFeatureAndNamespace, getStateByNamespace, isActionFromNamespace, preventNamespace };
